import './image-preview.scss';

import { Image, Tooltip } from 'antd';

import {
  DownloadOutlined,
  EyeOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  UndoOutlined,
  ZoomInOutlined,
  ZoomOutOutlined
} from '@/media/antd-icons';

interface IPropsPreviewAction {
  tooltip: string;
  action: () => void;
  children: (props: {
    className: string;
    onClick: () => void;
  }) => React.ReactNode;
}

interface IProps {
  base64: string;
  extension: string;
  fileName: string;
  onDownload: () => void;
  onError?: () => void;
  disableActions?: boolean;
}

const PreviewAction = ({ tooltip, action, children }: IPropsPreviewAction) => {
  return (
    <Tooltip title={tooltip} zIndex={100000} destroyOnHidden>
      {children({
        className: 'image-preview__toolbar-icon',
        onClick: action
      })}
    </Tooltip>
  );
};

const PreviewActionGroup = ({ children }: { children: React.ReactNode }) => {
  return <div className="image-preview__toolbar-group">{children}</div>;
};

const ImagePreview = ({
  base64,
  extension,
  fileName,
  onDownload,
  onError,
  disableActions
}: IProps) => {
  return (
    <Image
      alt={fileName}
      className="image-preview"
      src={`data:image/${extension};base64,${base64}`}
      onError={onError}
      preview={
        disableActions
          ? false
          : {
              maxScale: 10,
              title: <h3 className="image-preview__title">{fileName}</h3>,
              mask: <EyeOutlined className="image-preview__file-hover-icon" />,
              toolbarRender: (
                _,
                {
                  actions: {
                    onFlipY,
                    onFlipX,
                    onRotateLeft,
                    onRotateRight,
                    onZoomOut,
                    onZoomIn,
                    onReset
                  }
                }
              ) => (
                <div className="image-preview__toolbar">
                  {!disableActions && (
                    <PreviewAction tooltip="Скачать" action={onDownload}>
                      {(props) => <DownloadOutlined {...props} />}
                    </PreviewAction>
                  )}
                  <PreviewActionGroup>
                    <PreviewAction
                      tooltip="Отразить вертикально"
                      action={onFlipY}
                    >
                      {(props) => <SwapOutlined {...props} rotate={90} />}
                    </PreviewAction>
                    <PreviewAction
                      tooltip="Отразить горизонтально"
                      action={onFlipX}
                    >
                      {(props) => <SwapOutlined {...props} />}
                    </PreviewAction>
                  </PreviewActionGroup>
                  <PreviewActionGroup>
                    <PreviewAction
                      tooltip="Повернуть влево"
                      action={onRotateLeft}
                    >
                      {(props) => <RotateLeftOutlined {...props} />}
                    </PreviewAction>
                    <PreviewAction
                      tooltip="Повернуть вправо"
                      action={onRotateRight}
                    >
                      {(props) => <RotateRightOutlined {...props} />}
                    </PreviewAction>
                  </PreviewActionGroup>
                  <PreviewActionGroup>
                    <PreviewAction tooltip="Уменьшить" action={onZoomOut}>
                      {(props) => <ZoomOutOutlined {...props} />}
                    </PreviewAction>
                    <PreviewAction tooltip="Увеличить" action={onZoomIn}>
                      {(props) => <ZoomInOutlined {...props} />}
                    </PreviewAction>
                  </PreviewActionGroup>
                  <PreviewAction tooltip="Сбросить" action={onReset}>
                    {(props) => <UndoOutlined {...props} />}
                  </PreviewAction>
                </div>
              )
            }
      }
    />
  );
};

export default ImagePreview;
